import { useState } from "react";
import { trpc } from "@/lib/trpc";
import { useFeature } from "@/lib/use-feature";
import { usePermissao } from "@/lib/use-permissao";
import type { SalaDaColuna } from "@/lib/agenda-colunas";

const LS_POR_SALA = "agenda_porSala";

/**
 * A alternância "Por sala" da vista de dia. Só para quem vê a agenda de todos: com só as próprias
 * consultas, a cadeira de um colega pareceria livre.
 */
export function useAgendaPorSala(viewMode: string) {
  const temRecurso = useFeature("salas");
  const verTodos = usePermissao("agenda.viewAll");
  const salas = (trpc.salas.listar.useQuery(undefined, { enabled: temRecurso && verTodos, staleTime: 60_000 }).data ?? []) as SalaDaColuna[];
  const disponivel = temRecurso && verTodos && salas.length > 0;
  const [ligado, setLigado] = useState(() => {
    try {
      return localStorage.getItem(LS_POR_SALA) === "true";
    } catch {
      return false;
    }
  });
  const alternar = () =>
    setLigado((v) => {
      try {
        localStorage.setItem(LS_POR_SALA, String(!v));
      } catch {
        // Sem armazenamento (aba privada): vale só nesta visita.
      }
      return !v;
    });
  return {
    disponivel,
    ligado: disponivel && ligado,
    alternar,
    /** As colunas da grade — só na vista de dia, com a alternância ligada. */
    salas: disponivel && ligado && viewMode === "day" ? salas : null,
  };
}
